module.exports = __webpack_public_path__ + "8ed15bea1042e83e3c655036f94f34d0.pdf";